import { ICellRendererParams } from "ag-grid-community";
import {
  FlatProduct,
  OverlappedValue,
} from "@/features/line-sheet-sets/helpers/sheet-state";
import AppButton from "@/features/line-sheet-sets/app-button";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { useMemo } from "react";
import { AgGridUtils } from "@/features/ui/utils/ag-grid-utils";

export interface TakeAllProductsCellProps {
  isEditable?: boolean;
  isOrderEditable?: boolean;
}

export default function TakeAllProductsCell(
  props: TakeAllProductsCellProps & ICellRendererParams<FlatProduct, boolean>
) {
  const { api, data, node } = props;
  const { tTitle } = useI18nHelper();

  const isTakenAll = useMemo(() => {
    const nodeRowIndex = node.rowIndex as number;
    const stockData = api.getDisplayedRowAtIndex(nodeRowIndex - 1)?.data?.sizes;
    const orderData = data?.sizes;

    const getQuantity = (datum: number | OverlappedValue<number>) => {
      if (typeof datum === "number") {
        return datum;
      } else if (!datum) {
        return 0;
      } else {
        return datum.top;
      }
    };

    if (stockData && orderData) {
      // @ts-ignore
      return orderData.every(
        (orderDatum: number | OverlappedValue<number>, index: number) => {
          // 재고가 없는데 주문이 있다면 '전량 구매' 버튼 비활성화되어야 함.
          if (stockData.length <= index) {
            return true;
          }
          // 매칭이 잘못되면 오류가 발생할 수 있어서 방어로직 남겨둠
          if (!stockData[index]) {
            return false;
          }
          return (
            getQuantity(orderDatum) >=
            getQuantity(stockData[index] as number | OverlappedValue<number>)
          );
        }
      );
    }

    return true;
  }, [api, data, node]);

  if (!props.isOrderEditable) {
    return null;
  }
  return (
    <AppButton
      height={"22px"}
      isDisabled={isTakenAll}
      onClick={() => {
        AgGridUtils.dispatchCellEditEvent(true, props);
      }}
    >
      {tTitle("take_all")}
    </AppButton>
  );
}
